import React from 'react';
import Logo from '../Logo';

export default (props) => (
  <Logo
    src="img/logos/infomail/white.svg"
    type="white-infomail-logo"
    {...props}
  />
);
